import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onSave: '&',
        onClose: '&',
        occurrence: '=',
        training: '=',
        index: '=',
        participants: '=',
        isRoomOverbooked: '=',
        room: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'occurrence.Assign participants' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="alert alert-warn" ng-if="vm.isRoomOverbooked">{{ 'occurrence.More participants assigned than room capacity' | translate }}</div>
            <div class="alert alert-notify" ng-if="!vm.availableParticipants.length">{{ 'occurrence.No unassigned participants' | translate }}</div>
            <div class="form" ng-if="vm.availableParticipants.length">
                <form-row error="error" ng-repeat="error in vm.errors">
                    <form-row-error></form-row-error>
                </form-row>
                <ul class="checkboxes02">
                    <li class="right">
                        <a ng-click="vm.toggleAll()">{{ 'occurrence.Select all' | translate }}</a>
                    </li>
                    <li
                        ng-class="{
                            mt1em: $index === 0,
                            status04: item.isInActive
                        }"
                        ng-repeat="item in vm.availableParticipants">
                        <label>
                            <input type="checkbox" ng-checked="vm.hasParticipant(item.userId)" ng-click="vm.toggleParticipant(item.userId)"
                            ><span>{{ item.displayName }}<small ng-if="item.isInActive"> ({{ 'user.Inactive' | translate }})</small></span>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main"
                            type="button"
                            ng-click="vm.save()"
                            ng-class="{true: 'loading', false: ''}[vm.loading]"
                            ng-disabled="vm.loading"
                    >
                        {{ 'general.Save' | translate }}
                    </button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.onClose()">
                        {{ 'general.Cancel' | translate }}
                    </button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $scope, lodash, UserResource, OccurrenceResource, TokenService, ModalService) {
        this.$translate = $translate;
        this.$scope = $scope;
        this.UserResource = UserResource;
        this.OccurrenceResource = OccurrenceResource;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.lodash = lodash;

        this.loading = false;
    }

    $onInit () {
        this.errors = [];
        // make a copy of training so we don't change the original training
        this.trainingCopy = angular.copy(this.training);
        this.initAvailableParticipants();
    }

    initAvailableParticipants () {
        const excludedIds = this.trainingCopy.times
        // filtering away values we do not need
            .filter((time, key) => key !== this.index)
            // reducing an array of values into a single value (also an array)
            .reduce((original, time) => [...original, ...time.participantIds], []);
        this.availableParticipants = this.participants.filter(participant => !this.lodash.includes(excludedIds, participant.userId));
    }

    hasParticipant (id) {
        return this.lodash.includes(this.trainingCopy.times[this.index].participantIds, id);
    }

    toggleParticipant (id) {
        if (this.hasParticipant(id)) {
            this.lodash.pull(this.trainingCopy.times[this.index].participantIds, id);
            this.trainingCopy.times[this.index].participantCount--;
        }
        else {
            this.trainingCopy.times[this.index].participantIds.push(id);
            this.trainingCopy.times[this.index].participantCount++;
        }
    }

    toggleAll () {
        const selectedParticipants = this.trainingCopy.times[this.index].participantIds.length;
        if (selectedParticipants > 0) {
            this.trainingCopy.times[this.index].participantIds = [];
            this.trainingCopy.times[this.index].participantCount =
                this.trainingCopy.times[this.index].participantCount - selectedParticipants;
        }
        else {
            const availableParticipants = this.availableParticipants.map((obj) => (obj.userId));
            this.trainingCopy.times[this.index].participantIds = this.availableParticipants.map((obj) => (obj.userId));
            this.trainingCopy.times[this.index].participantCount = availableParticipants.length;
        }
    }

    save () {
        if (this.isOverCapacity()) {
            const message = this.$translate.instant('participants.confirm_over_capacity_message');
            this.ModalService.confirm(message, 'medium').then(() => {
                this.setTrainings();
            });
        }
        else {
            this.setTrainings();
        }
    }

    setTrainings () {
        this.loading = true;
        this.OccurrenceResource.setTrainings({ id: this.occurrence.id }, [this.trainingCopy]).$promise
            .then(() => this.handleSuccess())
            .catch(response => this.handleResponse(response))
            .finally(() => {
                this.loading = false;
            });
    }

    handleSuccess () {
        this.onSave();
        this.errors = [];
    }

    handleResponse (response) {
        if (response.status === 422 && response.data) {
            this.errors = response.data.map(item => item.message);
        }
    }

    isOverCapacity () {
        const trainingTime = this.trainingCopy.times[this.index];
        const participantsCount = trainingTime.participantCount;

        if (!this.room && !trainingTime.hasCapacity) {
            return false;
        }

        if (trainingTime.hasCapacity && trainingTime.capacity) {
            return trainingTime.capacity < participantsCount;
        }

        if (this.room && this.room.capacity) {
            return this.room.capacity < participantsCount;
        }

        return this.occurrence.trainingTimeCapacity && this.occurrence.trainingTimeCapacity < participantsCount;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/assignParticipants/index.js